import { useSearchParams } from "react-router-dom";
import Tracking from "../Tracking";
import TrackingTree from "../TrackingTree";

import "./styles/index.scss";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useLabels from "../../../hooks/useLabels";
import {
  getLotHistory,
  getLots,
  getLotTrackingTree,
  getTanks,
  getTankTrackingTree,
} from "../../../services/utils";
// import ReactFlowProvider from "react-flow-renderer";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { setTanks } from "../../../context/tanks/tanksSlice";
import {
  selectActiveWinery,
  selectAnalysis,
  selectConfigs,
  selectLots,
  selectTanks,
} from "../../../context/selectors";
import SecondaryBar from "../../SecondaryBar";
import { Button, CTA } from "../../Generic";

import ReactDatePicker from "react-datepicker";
import { addDays } from "date-fns";
import TabSelector from "../../TabSelector";
import { setLots } from "../../../context/lots/lotsSlice";
import { getItem, setItem } from "../../../services/LocalStorage";
import DataPlot from "../../DataPlot/DataPlot";
import AnalysisEvolution from "../../AnalysisEvolution/AnalysisEvolutions";
import { Input, MultipleSelect, Select } from "../../FormComponents";
import { useForm, useWatch } from "react-hook-form";

const TrackingWrapper = ({ type = "tank" }) => {
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const dispatch = useDispatch();
  const activeWinery = useSelector(selectActiveWinery);
  const tanks = useSelector(selectTanks);
  const lots = useSelector(selectLots);

  const axiosPrivate = useAxiosPrivate();

  const [tank, setTank] = useState({});
  const [lot, setLot] = useState({});
  const [traceData, setTraceData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowRange, setIsShowRange] = useState(false);

  const [getLabel] = useLabels();
  const navigate = useNavigate();

  const configs = useSelector(selectConfigs);

  const [activeTab, setActiveTab] = useState("tracking");
  const tabs = [
    {
      name: getLabel(type === "tank" ? "tankTrackingPage" : "lotTrackingPage", {
        name: "",
      }),
      anchor: "tracking",
    },
    {
      name: getLabel(
        type === "tank" ? "tankTrackingTreePage" : "lotTrackingTreePage",
        { name: "" }
      ),
      anchor: "tree",
    },
    {
      name: getLabel(
        type === "tank"
          ? "tankTrackingTreatmentsPage"
          : "lotTrackingTreatmentsPage",
        { name: "" }
      ),
      anchor: "substances",
    },
  ];

  const DEFAULT_START = new Date(new Date().getFullYear() - 1, 7, 1); // 1 agosto anno precedente
  const DEFAULT_END = new Date(); // oggi

  const [dates, setDates] = useState({
    startDate: DEFAULT_START, // august 1st
    endDate: DEFAULT_END, // today
  });

  const {
    formState: { errors, isValid },
    control,
    register,
  } = useForm({
    defaultValues: {
      variables: [], // for analysis evolution
    },
    mode: "onTouched",
  });

  const { variables, tank_id } = useWatch({ control });

  const pageName =
    type === "tank"
      ? getLabel("tankTrackingTitlePage", { name: tank?.name || id })
      : getLabel("lotTrackingTitlePage", { name: lot?.name || id });

      useEffect(() => {
    const isWithinDefaultRange =
      dates.startDate >= DEFAULT_START && dates.endDate <= DEFAULT_END;
    
    if (isWithinDefaultRange) {
      // filter operations locally
      setTraceData(
        (prev) =>
          prev?.filter((item) => {
            const date = new Date(item.completion_date);
            return date >= dates.startDate && date <= dates.endDate;
          }) || []
      );
    } else {
      // loads extended data
      loadTraceData(dates.startDate, dates.endDate);
    }
  }, [dates]);

  useEffect(() => {
    if (!tanks || tanks.length === 0) {
      loadTanks();
    }
    if (!lots || lots.length === 0) {
      loadLots();
    }

    loadTraceData();
    getLastActiveTab();
  }, []);

  useEffect(() => {
    if (type === "tank" && tanks && tanks.length > 0) {
      setTank(
        tanks.find((dbTank) => {
          return dbTank.id === Number(id);
        }) || {}
      );
    }
    if (type === "lot" && lots && lots.length > 0) {
      const foundLot = lots.find((dbLot) => {
        return dbLot.id === Number(id);
      });
      if (foundLot) setLot(foundLot || {});
      else {
        fetchLotHistory();
      }
    }
  }, [tanks, lots]);

  const fetchLotHistory = async () => {
    const foundLot = await getLotHistory(activeWinery.id, id, axiosPrivate);
    if (foundLot?.success && foundLot?.updated_data) {
      setLot(foundLot.updated_data || {});
    }
  };

  const getLastActiveTab = () => {
    try {
      const savedTab = getItem(`activeTab-tracking-${type}`);
      if (savedTab && tabs.some((tab) => tab.anchor === savedTab)) {
        setActiveTab(savedTab);
        return savedTab;
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  const loadTanks = async () => {
    const currentTanks = await getTanks(activeWinery.id, axiosPrivate);
    dispatch(setTanks(currentTanks));
  };

  const loadLots = async () => {
    const currentLots = await getLots(activeWinery.id, axiosPrivate);
    dispatch(setLots(currentLots));
  };

  const handleTabChange = (anchor) => {
    setActiveTab(anchor);
    setItem(`activeTab-tracking-${type}`, anchor);
  };

  const loadTraceData = async () => {
    const currentTraceData = await (type === "tank"
      ? getTankTrackingTree(axiosPrivate, id, dates)
      : getLotTrackingTree(axiosPrivate, id, dates));
    
    setTraceData(currentTraceData);
    setIsLoading(false);
  };

  const renderNavMenu = () => {
    const navClickHandler = () => {
      navigate(
        type === "tank" ? `/tanks/${id}` : type === "lot" ? `/lots/${id}` : "/"
      );
    };
    return (
      <div className="primary_container_menu">
        <div className="primary_container_row">
          <Button arrowDirection="left" onClick={navClickHandler} />
          <h2>{pageName}</h2>
        </div>
        <div className="primary_container_row ctas">
          {renderInterval()}
          <NavLink onClick={"print"}>
            <CTA>{getLabel("print")}</CTA>
          </NavLink>
        </div>
      </div>
    );
  };

  const renderInterval = () => {
    return (
      <div className="interval_row">
        <div className="interval_value">
          <span>{getLabel("dateFrom")}</span>
          <ReactDatePicker
            selected={dates.startDate}
            onChange={(date) =>
              setDates({
                ...dates,
                startDate: date.setHours(0, 0, 0),
              })
            }
            selectsStart
            // startDate={dates.startDate}
            // endDate={dates.endDate}
            maxDate={addDays(dates.endDate, -1)}
            dateFormat={configs.shortDateFormat}
          />
          <span>{getLabel("dateTo")}</span>
          <ReactDatePicker
            selected={dates.endDate}
            onChange={(date) =>
              setDates({
                ...dates,
                endDate: date.setHours(23, 59, 59),
              })
            }
            selectsEnd
            // startDate={dates.startDate}
            // endDate={dates.endDate}
            minDate={addDays(dates.startDate, 1)}
            maxDate={new Date()}
            dateFormat={configs.shortDateFormat}
          />
        </div>
      </div>
    );
  };

  const colorPalette = [
    "#1f77b4", // blue
    "#ff7f0e", // orange
    "#2ca02c", // green
    "#d62728", // red
    "#9467bd", // purple
    "#8c564b", // brown
    "#e377c2", // pink
    "#7f7f7f", // gray
    "#bcbd22", // olive
    "#17becf", // cyan
  ];

  const filterTreatmentByType = (op_type, t) => {
    // in case of analysis on GRAPE, returns all the operations (there is no path yet to track it)
    if (op_type === "ANALYSIS" && t?.source_batch_state === "GRAPE")
      return true;

    return type === "tank" || t?.batch_id === Number(tank_id);
  };

  const generatePlotVariables = (data) => {
    const variableMap = new Map();

    let colorIndex = 0;
    data?.forEach((op) => {
      const treatments = op?.treatments || [];
      treatments
        ?.filter((t) => filterTreatmentByType(op?.operation_type, t))
        ?.forEach((treatment) => {
          const {
            substance_id,
            substance_name,
            unit,
            collection_date,
            results,
            analyst,
            temperature,
          } = treatment;
          const color = colorPalette[colorIndex % colorPalette.length];
          colorIndex++;

          // Find corresponding value in `results` matching current substance_id
          const result = results?.find((r) => r?.substance_id === substance_id);
          if (!result) return;

          // Initialize the variable entry if it doesn't exist
          if (!variableMap.has(substance_id)) {
            variableMap.set(substance_id, {
              name: substance_name,
              translated_name:
                op?.operation_type === "ANALYSIS"
                  ? getLabel(`substance_${substance_name}`)
                  : getLabel(substance_name),
              unit,
              color: color || "rgb(100, 36, 46)", // fallback color
              data: [],
              tank_id: result?.tank_id,
              batch_id: result?.batch_id,
              tank_name: treatment?.tank_name,
              min: treatment?.min_range,
              max: treatment?.max_range,
            });
          }
          // Push value with date
          variableMap?.get(substance_id)?.data?.push({
            // tank_id: result?.tank_id,
            // batch_id: result?.batch_id,
            value: parseFloat(result?.value),
            // collection_date: collection_date?.toString(),
            date: new Date(collection_date).valueOf(),
            // fullDate: "02/06/2025 10:00",
            unit: unit || "",
            temperature,
            analyst,
          });
        });
    });

    return Array.from(variableMap?.values());
  };

  const getUniqueTanks = (plotVariables) => {
    const tankMap = new Map();

    plotVariables?.forEach((item) => {
      if (!tankMap.has(item?.tank_id)) {
        tankMap.set(item?.tank_id, {
          label: item?.tank_name,
          value: item?.tank_id,
        });
      }
    });

    return Array.from(tankMap.values());
  };

  const renderAnalysisEvolution = () => {
    const filteredAnalysisResults = traceData?.filter(
      (t) =>
        [
          "ADD",
          "TREATMENT",
          "ANALYSIS",
          "ENZYME",
          "BOIS",
          "TANNISSAGE",
          "SO2",
          "NITROGEN",
          // 'HOMOGENIZATION_MASS', 'OXYGENATION', 'INOCULATION'
        ].includes(t?.operation_type) &&
        t.completion_date &&
        t.completion_date !== null
    );
    console.log('filteredAnalysisResults', filteredAnalysisResults)
    const plotVariables = generatePlotVariables(filteredAnalysisResults);
    console.log('plotVariables', plotVariables)
    
    return (
      <div>
        <div className="primary_container_menu">
          <h4>{getLabel("analysisVariables")}</h4>
          {plotVariables?.length > 0 && (
            <div className="variables_wrapper">
              <MultipleSelect
                name="variables"
                control={control}
                label={getLabel("examVariables")}
                placeholder={getLabel("examVariablesPlaceholder")}
                error={errors["label"]}
                // required={getLabel("inputRequiredError")}
                options={plotVariables?.map((v) => {
                  return { label: v?.translated_name, value: v?.name };
                })}
                tooltip={getLabel("examVariablesTooltip")}
              />
              {type === "lot" && lot?.state !== "GRAPE" && (
                <Select
                  name="tank_id"
                  control={control}
                  isDisabled={variables?.length === 0}
                  label={getLabel("analysisTanks")}
                  placeholder={getLabel("analysisTanksPlaceholder")}
                  error={errors["tank_id"]}
                  required={getLabel("inputRequiredError")}
                  options={getUniqueTanks(plotVariables)}
                  // tooltip={getLabel("analysisTanksTooltip")}
                />
              )}
              <Input
                name={"is_show_range"}
                register={register}
                error={errors["is_show_range"]}
                type={"checkbox"}
                label={getLabel(
                  isShowRange ? "analysisHideRange" : "analysisShowRange"
                )}
                checked={isShowRange}
                onChange={() => setIsShowRange((prev) => !prev)}
                customClassName={"confirm no_margin_top"}
              />
            </div>
          )}
        </div>
        {plotVariables?.length === 0 && (
          <h5 className="alert_no_info">
            {getLabel("tankTimelineAnalysisNoData")}
          </h5>
        )}
        {plotVariables?.length > 0 && variables?.length === 0 && (
          <h5 className="alert_no_info">{getLabel("noVariablesSelected")}</h5>
        )}
        {variables?.length > 0 && (
          <DataPlot
            data={plotVariables?.filter((p) =>
              variables?.some((v) => v?.value === p?.name)
            )}
            isShowInterval={false}
            isShowRange={isShowRange}
          />
        )}
      </div>
    );
  };

  return (
    <div className="primary_container">
      <SecondaryBar
        breadCrumb={[
          type === "tank"
            ? { label: getLabel("tanksNavLink"), link: "/tanks" }
            : { label: getLabel("lotsNavLink"), link: "/lots" },
          activeTab === "tree"
            ? getLabel(
                type === "tank"
                  ? "tankTrackingTreePage"
                  : "lotTrackingTreePage",
                { name: "" }
              )
            : activeTab === "tracking"
            ? getLabel(
                type === "tank" ? "tankTrackingPage" : "lotTrackingPage",
                { name: "" }
              )
            : getLabel(
                type === "tank"
                  ? "tankTrackingTreatmentsPage"
                  : "lotTrackingTreatmentsPage",
                { name: "" }
              ),
        ]}
      />
      {renderNavMenu()}
      <div className="tracking_tabs">
        <TabSelector
          tabs={tabs}
          onTabChange={handleTabChange}
          activeTab={activeTab}
        />
      </div>
      {activeTab === "tree" ? (
        <TrackingTree
          type={type}
          dates={dates}
          traceData={traceData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : activeTab === "tracking" ? (
        <Tracking
          type={type}
          lot={lot}
          tank={tank}
          lots={lots}
          tanks={tanks}
          dates={dates}
          traceData={traceData}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      ) : (
        <div>{renderAnalysisEvolution()}</div>
        // <DataPlot data={traceData?.filter(
        //   (v) => ['TREATMENT', 'ANALYSIS', 'ENZYME', 'BOIS', 'TANNISSAGE', 'SO2', 'NITROGEN',
        //     // 'HOMOGENIZATION_MASS', 'OXYGENATION', 'INOCULATION'
        //   ].includes(v?.operation_type) && v.completion_date && v.completion_date !== null
        // )}/>
      )}
    </div>
  );
};

export default TrackingWrapper;
